module.exports = __webpack_public_path__ + "static/media/gsg_logo.c00f6695.svg";